import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  icon: { marginRight: 8 },
}));
